import React, { createContext, useState,useRef,useContext,useEffect,useCallback } from "react"; //
import { toastProperties } from "../components/Toast/Toast";
import socketIO from "socket.io-client";
// Create a Context
export const TimerContext = createContext();

// Create a Provider Component
export const TimerProvider = ({ children }) => {
    const [listToast, setListToast] = useState([]);  
    const [prepareToStop, setToStop] = useState([]);
    const [isConnected, setIsConnected] = useState(false); // Server status
    const [arduinoConnected, setArduinoConnected] = useState(false); // Arduino status
    const socketRef = useRef(null);
    
    const api_server = localStorage.getItem("api_server") || null;

    const connectSocket = useCallback(() => {
        if (!api_server) return;

        // If socket already exists, disconnect first to avoid duplicates
        if (socketRef.current) {
            socketRef.current.disconnect();
        }

        socketRef.current = socketIO.connect(api_server, { reconnection: false });
        socketRef.current.off("connect");
        socketRef.current.off("disconnect");
        socketRef.current.off("arduinoStatus");

        try {
            socketRef.current = socketIO.connect(api_server);

            socketRef.current.on("connect", () => {
                console.log("✅ Connected to server!");
                setIsConnected(true);
            });

            socketRef.current.on("disconnect", () => {
                console.log("⚠️ Disconnected from server.");
                setIsConnected(false);
                setArduinoConnected(false); // Reset Arduino status when server disconnects
            });

            socketRef.current.on("arduinoStatus", (data) => {
                console.log("🔌 Sensor Status:", data.connected ? "Connected" : "Disconnected");
                setArduinoConnected(data.connected);
            });

        } catch (e) {
            console.error("❌ Socket connection error:", e);
        }
    }, [api_server]);

    useEffect(() => {
        // Initialize the socket connection
        connectSocket();

        // Cleanup on unmount
        return () => {
            if (socketRef.current) {
                socketRef.current.disconnect();
                console.log("Socket disconnected.");
            }
        };
    }, [connectSocket]);

    const reconnect = () => {
        console.log("🔄 Reconnecting...");
        // if (socketRef.current) {
        //     socketRef.current.disconnect();
        // }
        connectSocket();
    };

    const deleteToast = id => { 
        const toastListItem = listToast.findIndex(e => e.id === id); 
        listToast.splice(toastListItem, 1);
        setListToast([...listToast]);
    };
    const showToast = (type,message,title)=>{ 
        let toast = toastProperties(type,message,title);  
        setListToast([...listToast, toast]);   
    };

    const toggleCard = (id) => {
        if (prepareToStop.includes(id)) {
            setToStop(prepareToStop.filter((cardIndex) => cardIndex !== id));
        } else {
            setToStop([...prepareToStop, id]);
        }
    };

    const positionId = (id)=>{
        let index = prepareToStop.indexOf(id);
        return index+1;
    };
    
    return (
        <TimerContext.Provider value={{ 
            listToast, 
            setListToast,
            deleteToast,
            showToast,
            prepareToStop,
            setToStop,
            toggleCard,
            positionId,
            socketRef,
            isConnected,
            reconnect,
            arduinoConnected
        }}>
            {children}
        </TimerContext.Provider>
    );
};

export const useSocket = () => {
    return useContext(TimerProvider);
};
